<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-primary text-on-primary print:hidden"
  [appearance]="'compact'"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation()"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex items-center justify-center h-20 mt-3 mb-4">
      <ng-container *ngIf="enableGlobalSearch; else elseBlock">
        <button mat-icon-button (click)="logoClick.emit()">
          <img class="w-10 rounded-md" [src]="logoSrc | async" alt="Logo Image" />
        </button>
      </ng-container>
      <ng-template #elseBlock>
        <img class="w-10 rounded-md" [src]="logoSrc | async" alt="Logo Image" />
      </ng-template>
    </div>
  </ng-container>

  <ng-container fuseVerticalNavigationFooter>
    <ng-content select="[fuseVerticalNavigationFooter]"></ng-content>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div
    class="sticky top-0 xxs:relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card print:hidden"
  >
    <!-- Navigation toggle button -->
    <button
      data-test="button-access-vertical-navigation-menu"
      mat-icon-button
      (click)="toggleNavigation('mainNavigation')"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <!-- Components -->
    <div
      class="flex items-center pl-2 space-x-0.5 sm:space-x-2"
      [ngClass]="{ 'ml-auto': !enableGlobalSearch, 'w-full': enableGlobalSearch }"
    >
      <ng-content select="[primaryMenu]"></ng-content>
      <fuse-fullscreen class="hidden md:block" [tooltip]="fullscreenTooltip"></fuse-fullscreen>
      <ng-content></ng-content>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <router-outlet *ngIf="true"></router-outlet>
  </div>
</div>
